import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const LocationComparison = ({ onCompare }) => {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [serviceType, setServiceType] = useState('');

  const locations = [
    {
      value: 'bangalore',
      label: 'Bangalore',
      description: 'Silicon Valley of India',
      averageSalary: 28000,
      infrastructure: 'Excellent',
      talent: 'Premium',
      costIndex: 1.15,
      timezone: 'UTC+5:30',
      languages: ['English', 'Hindi', 'Kannada']
    },
    {
      value: 'hyderabad',
      label: 'Hyderabad',
      description: 'Cyberabad Tech Hub',
      averageSalary: 25000,
      infrastructure: 'Very Good',
      talent: 'High Quality',
      costIndex: 1.05,
      timezone: 'UTC+5:30',
      languages: ['English', 'Hindi', 'Telugu']
    },
    {
      value: 'pune',
      label: 'Pune',
      description: 'IT & Automotive Center',
      averageSalary: 26000,
      infrastructure: 'Good',
      talent: 'Diverse',
      costIndex: 1.08,
      timezone: 'UTC+5:30',
      languages: ['English', 'Hindi', 'Marathi']
    },
    {
      value: 'chennai',
      label: 'Chennai',
      description: 'Detroit of India',
      averageSalary: 24000,
      infrastructure: 'Good',
      talent: 'Strong Technical',
      costIndex: 1.02,
      timezone: 'UTC+5:30',
      languages: ['English', 'Tamil', 'Hindi']
    },
    {
      value: 'mumbai',
      label: 'Mumbai',
      description: 'Financial Capital',
      averageSalary: 32000,
      infrastructure: 'Excellent',
      talent: 'Premium',
      costIndex: 1.25,
      timezone: 'UTC+5:30',
      languages: ['English', 'Hindi', 'Marathi']
    },
    {
      value: 'delhi-ncr',
      label: 'Delhi NCR',
      description: 'Government & Enterprise Hub',
      averageSalary: 30000,
      infrastructure: 'Very Good',
      talent: 'Diverse',
      costIndex: 1.18,
      timezone: 'UTC+5:30',
      languages: ['English', 'Hindi', 'Punjabi']
    },
    {
      value: 'kochi',
      label: 'Kochi',
      description: 'Emerging IT Destination',
      averageSalary: 22000,
      infrastructure: 'Developing',
      talent: 'Growing',
      costIndex: 0.95,
      timezone: 'UTC+5:30',
      languages: ['English', 'Malayalam', 'Hindi']
    },
    {
      value: 'ahmedabad',
      label: 'Ahmedabad',
      description: 'Cost-Effective Operations',
      averageSalary: 21000,
      infrastructure: 'Good',
      talent: 'Emerging',
      costIndex: 0.92,
      timezone: 'UTC+5:30',
      languages: ['English', 'Hindi', 'Gujarati']
    }
  ];

  const serviceTypes = [
    { value: 'software-development', label: 'Software Development' },
    { value: 'data-analytics', label: 'Data Analytics & AI' },
    { value: 'customer-support', label: 'Customer Support' },
    { value: 'finance-accounting', label: 'Finance & Accounting' },
    { value: 'hr-operations', label: 'HR Operations' },
    { value: 'research-development', label: 'Research & Development' }
  ];

  const locationOptions = locations.map(loc => ({
    value: loc.value,
    label: loc.label,
    description: loc.description
  }));

  const handleLocationChange = (values) => {
    setSelectedLocations(values);
  };

  const handleCompare = () => {
    if (selectedLocations.length >= 2 && serviceType) {
      const selectedLocationData = locations.filter(loc => 
        selectedLocations.includes(loc.value)
      );
      onCompare({
        locations: selectedLocationData,
        serviceType
      });
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div 
      className="rounded-xl p-6 shadow-executive"
      style={{
        backgroundColor: '#0f172a',
        border: '1px solid #475569',
        color: '#f8fafc'
      }}
    >
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 gradient-executive rounded-lg flex items-center justify-center">
          <Icon name="MapPin" size={20} color="white" />
        </div>
        <div>
          <h3 
            className="font-headline font-semibold text-lg"
            style={{ color: '#f8fafc' }}
          >
            Location Comparison Tool
          </h3>
          <p 
            className="text-sm"
            style={{ color: '#cbd5e1' }}
          >
            Compare costs and capabilities across Indian cities
          </p>
        </div>
      </div>

            <div className="space-y-6">
        <div className="mobile-form-stack md:grid md:grid-cols-2 gap-4 md:gap-6">
          <Select
            label="Select Locations to Compare"
            placeholder="Choose 2-4 locations"
            options={locationOptions}
            value={selectedLocations}
            onChange={handleLocationChange}
            multiple
            searchable
            description="Select at least 2 locations for comparison"
            className="mobile-input-full"
          />

          <Select
            label="Service Type"
            placeholder="Select service type"
            options={serviceTypes}
            value={serviceType}
            onChange={setServiceType}
            searchable
            description="Service type affects talent availability and costs"
            className="mobile-input-full"
          />
        </div>

        {selectedLocations.length > 0 && (
          <div className="space-y-4">
            <h4 
              className="font-medium"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Selected Locations Preview
            </h4>
            <div className="mobile-card-grid md:grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
              {selectedLocations.map(locationValue => {
                const location = locations.find(loc => loc.value === locationValue);
                return (
                  <div 
                    key={locationValue} 
                    className="rounded-lg p-3 md:p-4 mobile-card-full"
                    style={{ 
                      border: '1px solid var(--color-border)',
                      backgroundColor: 'var(--color-surface)'
                    }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <h5 
                        className="font-medium"
                        style={{ color: 'var(--color-text-primary)' }}
                      >
                        {location.label}
                      </h5>
                      <div className={`px-2 py-1 rounded text-xs ${
                        location.costIndex <= 1.0 ? 'bg-success/10 text-success' :
                        location.costIndex <= 1.1 ? 'bg-warning/10 text-warning': 'bg-error/10 text-error'
                      }`}>
                        {location.costIndex <= 1.0 ? 'Low Cost' :
                         location.costIndex <= 1.1 ? 'Moderate' : 'Premium'}
                      </div>
                    </div>
                    
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span style={{ color: 'var(--color-text-secondary)' }}>Avg. Salary:</span>
                        <span style={{ color: 'var(--color-text-primary)' }}>{formatCurrency(location.averageSalary)}</span>
                      </div>
                      <div className="flex justify-between">
                        <span style={{ color: 'var(--color-text-secondary)' }}>Infrastructure:</span>
                        <span style={{ color: 'var(--color-text-primary)' }}>{location.infrastructure}</span>
                      </div>
                      <div className="flex justify-between">
                        <span style={{ color: 'var(--color-text-secondary)' }}>Talent Pool:</span>
                        <span style={{ color: 'var(--color-text-primary)' }}>{location.talent}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div 
          className="rounded-lg p-3 md:p-4"
          style={{ backgroundColor: 'var(--color-muted)' }}
        >
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} color="var(--color-accent)" />
            <div>
              <h4 
                className="font-medium mb-1"
                style={{ color: 'var(--color-text-primary)' }}
              >
                Comparison Factors
              </h4>
              <p 
                className="text-sm"
                style={{ color: 'var(--color-text-secondary)' }}
              >
                Our comparison includes salary benchmarks, infrastructure quality, talent availability, cost of living, regulatory environment, and timezone advantages for your specific service requirements.
              </p>
            </div>
          </div>
        </div>

        <Button
          variant="default"
          size="lg"
          fullWidth
          onClick={handleCompare}
          disabled={selectedLocations.length < 2 || !serviceType}
          className="bg-cta hover:bg-cta/90 text-cta-foreground touch-target"
          iconName="BarChart3"
          iconPosition="left"
        >
          <span className="mobile-text-sm md:text-base">
            Compare Locations ({selectedLocations.length} selected)
          </span>
        </Button>
      </div>
    </div>
  );
};

export default LocationComparison;